import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface Ticket {
  id: number;
  subject: string;
  type: TicketType;
  status: TicketStatus;
  priority: TicketPriority;
  created_at: string;
  closed_at: string;
  category: number;
  office_id: number;
  agreement_id: number;
  creator_user_id: number;
  creator_user_type: "user" | "landlord";
  visible_to_company: boolean;
}

interface TicketCreate {
  subject: string;
  type: TicketType;
  category: number;
  office_id?: number;
  user_id: number;
  visible_to_company: boolean;
  priority?: TicketPriority;
}

export interface TicketMessage {
  id: number;
  ticket_id: number;
  creator_user_id: number;
  creator_user_type: "user" | "landlord";
  creator_user_name: string;
  content: string;
  attachments: string[];
  created_at: string;
}

interface CreateTicketMessage {
  content: string;
  attachments: string[];
}

export interface TicketCategory {
  id: number;
  display_name: string;
  type: TicketType;
}

export type TicketType = "user_to_landlord" | "to_platform";
export type TicketPriority = "low" | "medium" | "high" | "urgent";
export type TicketStatus = "open" | "in_progress" | "closed";

export function TicketsAPI(baseUrl: string) {
  return {
    list: async (type: TicketType) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/tickets/${type}/?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Ticket[]>;
    },
    get: async (type: TicketType, id: number) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/tickets/${type}/${id}/?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Ticket>;
    },
    create: async (userData: TicketCreate) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.post(
        `${baseUrl}/tickets/${userData.type}/?renter_id=${renterId}`,
        userData,
        true,
      )) as ApiResponse<Ticket>;
    },
    close: async (type: TicketType, id: number) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.post(
        `${baseUrl}/tickets/${type}/${id}/close/?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Ticket>;
    },
    messages: {
      list: async (type: TicketType, id: number) => {
        const renterId = rootStore.getState().location.location.id;
        return (await crud.get(
          `${baseUrl}/tickets/${type}/${id}/messages/?renter_id=${renterId}`,
          undefined,
          true,
        )) as ApiResponse<TicketMessage[]>;
      },
      create: async (
        type: TicketType,
        id: number,
        messageData: CreateTicketMessage,
      ) => {
        const renterId = rootStore.getState().location.location.id;
        return (await crud.post(
          `${baseUrl}/tickets/${type}/${id}/messages/?renter_id=${renterId}`,
          messageData,
          true,
        )) as ApiResponse<TicketMessage>;
      },
    },
    categories: {
      list: async (type: TicketType) => {
        const renterId = rootStore.getState().location.location.id;
        return (await crud.get(
          `${baseUrl}/tickets/${type}/categories/?renter_id=${renterId}`,
          undefined,
          true,
        )) as ApiResponse<TicketCategory[]>;
      },
    },
  };
}
